(function () {
  function init() {
    initReveal();
    initMenu();
    initProduct();
    initCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initReveal() {
    var revealElements = document.querySelectorAll('[data-reveal]');
    if (revealElements.length === 0) return;

    if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
      revealElements.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    revealElements.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-menu]');
    if (!toggle || !menu) return;

    function setOpen(open) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? toggle.dataset.labelClose : toggle.dataset.labelOpen);
      menu.classList.toggle('is-open', open);
      document.body.classList.toggle('is-menu-open', open);
    }

    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    menu.addEventListener('click', function (event) {
      if (event.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setOpen(false);
        toggle.focus();
      }
    });

    window.matchMedia('(min-width: 900px)').addEventListener('change', function (event) {
      if (event.matches) setOpen(false);
    });
  }

  function initProduct() {
    var root = document.querySelector('[data-product-section]');
    if (!root) return;

    root.classList.add('is-enhanced');

    var gallery = initGallery(root);
    initQuantity(root);
    initVariants(root, gallery);
    initAddToCart(root);
  }

  function initGallery(root) {
    var viewport = root.querySelector('[data-gallery-viewport]');
    if (!viewport) return null;

    var slides = Array.prototype.slice.call(viewport.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gallery-thumb]'));
    if (slides.length < 2) return null;

    function setActive(index) {
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    function scrollToIndex(index) {
      if (index < 0 || index >= slides.length) return;
      viewport.scrollTo({
        left: index * viewport.clientWidth,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    }

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () {
        scrollToIndex(index);
        setActive(index);
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(slides.indexOf(entry.target));
          });
        },
        { root: viewport, threshold: 0.6 }
      );
      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }

    setActive(0);

    return {
      scrollToImageId: function (imageId) {
        if (!imageId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].dataset.imageId === String(imageId)) {
            scrollToIndex(i);
            setActive(i);
            return;
          }
        }
      }
    };
  }

  function initQuantity(root) {
    var input = root.querySelector('[data-quantity-input]');
    if (!input) return;

    root.querySelectorAll('[data-quantity-change]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = parseInt(button.dataset.quantityChange, 10);
        var value = parseInt(input.value, 10);
        if (isNaN(value)) value = 1;
        input.value = Math.max(1, value + step);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initVariants(root, gallery) {
    var select = root.querySelector('[data-variant-select]');
    var dataElement = root.querySelector('[data-variant-data]');
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-input]'));
    if (!select || !dataElement || optionInputs.length === 0) return;

    var variants;
    try {
      variants = JSON.parse(dataElement.textContent);
    } catch (error) {
      return;
    }

    select.setAttribute('aria-hidden', 'true');
    select.setAttribute('tabindex', '-1');

    var priceCurrent = root.querySelector('[data-price-current]');
    var priceCompare = root.querySelector('[data-price-compare]');
    var addButton = root.querySelector('[data-add-button]');
    var addLabel = root.querySelector('[data-add-label]');
    var labels = {
      add: addLabel ? addLabel.dataset.labelAdd : '',
      soldOut: addLabel ? addLabel.dataset.labelSoldOut : '',
      unavailable: addLabel ? addLabel.dataset.labelUnavailable : ''
    };

    function selectedOptions() {
      return optionInputs
        .filter(function (input) {
          return input.checked;
        })
        .map(function (input) {
          return input.value;
        });
    }

    function findVariant(values) {
      return variants.filter(function (variant) {
        return variant.options.length === values.length && variant.options.every(function (option, index) {
          return option === values[index];
        });
      })[0];
    }

    function update() {
      var variant = findVariant(selectedOptions());

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel && labels.unavailable) addLabel.textContent = labels.unavailable;
        return;
      }

      select.value = variant.id;

      if (priceCurrent) priceCurrent.textContent = variant.price;

      if (priceCompare) {
        if (variant.compare_at_price) {
          priceCompare.textContent = variant.compare_at_price;
          priceCompare.hidden = false;
        } else {
          priceCompare.textContent = '';
          priceCompare.hidden = true;
        }
      }

      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? labels.add : labels.soldOut;

      if (gallery) gallery.scrollToImageId(variant.image_id);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', update);
    });
  }

  function initAddToCart(root) {
    var form = root.querySelector('.product__form');
    var status = root.querySelector('[data-add-status]');
    var button = root.querySelector('[data-add-button]');
    var cartLink = root.querySelector('[data-cart-link]');
    if (!form || !status || !button) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      button.disabled = true;
      status.textContent = '';
      status.classList.remove('is-error');
      if (cartLink) cartLink.hidden = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add_failed');
          return response.json();
        })
        .then(function () {
          status.textContent = status.dataset.messageSuccess;
          if (cartLink) cartLink.hidden = false;
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
            return response.json();
          });
        })
        .then(function (cart) {
          var count = document.querySelector('[data-cart-count]');
          if (count) count.textContent = '(' + cart.item_count + ')';
        })
        .catch(function () {
          status.textContent = status.dataset.messageError;
          status.classList.add('is-error');
        })
        .finally(function () {
          button.disabled = false;
        });
    });
  }

  function initCart() {
    var root = document.querySelector('[data-cart-root]');
    if (!root) return;

    root.classList.add('is-enhanced');
    var sectionId = root.dataset.sectionId;

    function restoreFocus(selector) {
      var target = selector ? root.querySelector(selector) : null;

      if (!target) {
        target = root.querySelector('.cart__checkout') || root.querySelector('.cart__empty .button');
      }

      if (!target) {
        target = root.querySelector('.cart__title');
        if (target) target.setAttribute('tabindex', '-1');
      }

      if (target) target.focus({ preventScroll: prefersReducedMotion() });
    }

    function updateLine(line, quantity, focusSelector) {
      root.classList.add('is-loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: line,
          quantity: quantity,
          sections: sectionId,
          sections_url: window.location.pathname
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart_error');
          return response.json();
        })
        .then(function (cart) {
          var count = document.querySelector('[data-cart-count]');
          if (count) count.textContent = '(' + cart.item_count + ')';

          var markup = cart.sections && cart.sections[sectionId];
          if (!markup) {
            window.location.reload();
            return;
          }

          var parsed = new DOMParser().parseFromString(markup, 'text/html');
          var fresh = parsed.querySelector('[data-cart-root]');
          if (!fresh) {
            window.location.reload();
            return;
          }

          root.innerHTML = fresh.innerHTML;
          restoreFocus(focusSelector);
        })
        .catch(function () {
          window.location.reload();
        })
        .finally(function () {
          root.classList.remove('is-loading');
        });
    }

    root.addEventListener('click', function (event) {
      var stepper = event.target.closest('[data-quantity-change]');
      if (stepper) {
        var input = root.querySelector('[data-quantity-input][data-line="' + stepper.dataset.line + '"]');
        if (!input) return;
        var step = parseInt(stepper.dataset.quantityChange, 10);
        var value = parseInt(input.value, 10);
        if (isNaN(value)) value = 1;
        var stepperSelector =
          '[data-quantity-change="' + stepper.dataset.quantityChange + '"][data-line="' + stepper.dataset.line + '"]';
        updateLine(parseInt(stepper.dataset.line, 10), Math.max(1, value + step), stepperSelector);
        return;
      }

      var remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        // The removed line's controls are gone, and the same index now points at a
        // different product: never hand focus to another item's Remove action.
        updateLine(parseInt(remove.dataset.line, 10), 0, null);
      }
    });

    root.addEventListener('change', function (event) {
      var input = event.target.closest('[data-quantity-input]');
      if (!input) return;
      var value = parseInt(input.value, 10);
      if (isNaN(value)) value = 1;
      updateLine(
        parseInt(input.dataset.line, 10),
        Math.max(1, value),
        '[data-quantity-input][data-line="' + input.dataset.line + '"]'
      );
    });
  }
})();
